import _arrayPush_default from "./_arrayPush.js";
import _getPrototype_default from "./_getPrototype.js";
import stubArray_default from "./stubArray.js";
import _getSymbols_default from "./_getSymbols.js";

//#region ../../node_modules/lodash-es/_getSymbolsIn.js
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
* Creates an array of the own and inherited enumerable symbols of `object`.
*
* @private
* @param {Object} object The object to query.
* @returns {Array} Returns the array of symbols.
*/
var getSymbolsIn = !nativeGetSymbols ? stubArray_default : function(object) {
	var result = [];
	while (object) {
		_arrayPush_default(result, _getSymbols_default(object));
		object = _getPrototype_default(object);
	}
	return result;
};
var _getSymbolsIn_default = getSymbolsIn;

//#endregion
export { _getSymbolsIn_default as default };
//# sourceMappingURL=_getSymbolsIn.js.map